import { defineMessages } from 'react-intl';

export default defineMessages({
    caption: {
        id: '_.funding_requirements.sign_document_caption',
        defaultMessage: `This document requires {requiresNonApplicantSigning, select,
        true {{formattedPersonToSign}}
        false {a}
        other {}
        } digital signature.`
    },
    caption_completed: {
        id: '_.funding_requirements.sign_document_caption_completed',
        defaultMessage: 'Your signed document is available for download.'
    },
    access_user_caption_completed: {
        id: '_.funding_requirements.sign_document_access_user_caption_completed',
        defaultMessage:
            '{formattedPersonForCaption} signed the personal guarantee.'
    },
    action: {
        id: '_.funding_requirements.sign_document_action',
        defaultMessage: 'View & Sign'
    },
    action_wet: {
        id: '_.funding_requirements.sign_document_action_wet',
        defaultMessage: 'Download & Sign'
    },
    master_loan_agreement_label: {
        id: '_.draw_down.step_buttons.loan_agreement.label',
        defaultMessage: 'Credit Agreement'
    },
    secci_label: {
        id: '_.draw_down.step_buttons.secci.label',
        defaultMessage: 'SECCI'
    },
    reasonable_explanation_label: {
        id: '_.draw_down.step_buttons.reasonable_explanation.label',
        defaultMessage: 'Pre-contract Explanation'
    },
    guarantee_label: {
        id: '_.draw_down.step_buttons.guarantor_agreement.label',
        defaultMessage:
            '{requiresNonApplicantSigning, select, true {{formattedPersonToSign}} false {Your} other {}} Personal Guarantee'
    },
    repeat_loan_agreement: {
        id: '_.draw_down.step_buttons.repeat_loan_agreement.label',
        defaultMessage: 'Credit Agreement'
    },
    companies_house_charge_label: {
        id: '_.draw_down.step_buttons.companies_house_charge.label',
        defaultMessage: 'Debenture / Scottish Bond'
    },
    wetSignDocumentsFooter: {
        id: '_.draw_down.sign_documents.wetSignDocumentsFooter',
        defaultMessage:
            'Once you sign these documents please send a scanned copy to {documentsLink}'
    },
    documentsEmailAddress: {
        id: '_.draw_down.sign_documents.emailAddress',
        defaultMessage: 'documents@iwoca.co.uk'
    },
    companyName: {
        id: '_.draw_down.sign_documents.companyName',
        defaultMessage: 'Company name'
    },
    addressLineOne: {
        id: '_.draw_down.sign_documents.addressLineOne',
        defaultMessage: 'Address line one'
    },
    addressLineTwo: {
        id: '_.draw_down.sign_documents.addressLineTwo',
        defaultMessage: 'Address line two'
    },
    addressLineThree: {
        id: '_.draw_down.sign_documents.addressLineThree',
        defaultMessage: 'N/A'
    }
});
